// Client-side mirror of backend/src/utils/passwordPolicy.js, only to give instant
// feedback in the account form. The server is the authority: keep the two in step.

export const MIN_LENGTH = 12;
export const MAX_BYTES = 72;

/** A message when the form cannot be submitted, otherwise null. */
export function validatePasswordChange({ current, next, confirm }) {
  if (!current) return 'Enter your current password.';
  if (!next) return 'Enter a new password.';
  if ([...next].length < MIN_LENGTH) return `The new password must be at least ${MIN_LENGTH} characters.`;
  if (new TextEncoder().encode(next).length > MAX_BYTES) return `The new password is too long (at most ${MAX_BYTES} bytes).`;
  if (next === current) return 'The new password must be different from the current one.';
  if (next !== confirm) return 'The new password and its confirmation do not match.';
  return null;
}
